import { IconProps } from "./types";
import React from "react";

export const WarningIcon = ({
  className,
  fill = "currentColor",
  width = 10,
  height = 9,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 10 9"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M0 9H10L5 0L0 9ZM5.45385 7.5793H4.54487V6.63576H5.45385V7.5793ZM5.45385 5.68414H4.54487V3.78898H5.45385V5.68414Z"
      fill={fill}
    />
  </svg>
);
